import React from 'react';
import { Caption, Image, SimpleCell, SimpleCellProps, Tappable } from '@vkontakte/vkui';
import { Icon24Cancel } from '@vkontakte/icons';
import { FreeFocusWrapper } from '@dui';
import styles from './MessageBubbleAttachReply.module.css';

interface MessageBubbleAttachReplyProps extends SimpleCellProps {
  title: string;
  before?: string;
  subtitle: string;
  cancelAreaLabel: string;
  onClick?: VoidFunction;
  onCancel?: VoidFunction;
  titleTestId?: string;
  contentTestId?: string;
  cancelButtonTestId?: string;
}

export function MessageBubbleAttachReply(props: MessageBubbleAttachReplyProps) {
  const {
    title,
    subtitle,
    cancelAreaLabel,
    onCancel,
    cancelButtonTestId,
    contentTestId,
    titleTestId,
    before,
    ...rest
  } = props;

  const onCancelHandler = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    if (onCancel) {
      onCancel();
    }
  };

  return (
    <SimpleCell
      data-testid="attach-reply"
      className={styles.root}
      before={
        <>
          <div className={styles.line} />
          {before && <Image size={36} className={styles.image} src={before} />}
        </>
      }
      after={
        onCancel && (
          <FreeFocusWrapper>
            <Tappable
              data-testid={cancelButtonTestId}
              onClick={onCancelHandler}
              className={styles.cancelIcon}
              hoverMode="opacity"
              activeMode="opacity"
              area-label={cancelAreaLabel}
            >
              <Icon24Cancel fill="var(--vkui--color_icon_secondary)" />
            </Tappable>
          </FreeFocusWrapper>
        )
      }
      subtitle={
        <div data-testid={contentTestId} className={styles.subtitle}>
          {subtitle}
        </div>
      }
      {...rest}
    >
      <Caption data-testid={titleTestId} className={styles.title} level="1" weight="3" useAccentWeight>
        {title}
      </Caption>
    </SimpleCell>
  );
}
